import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { ServiceType } from '../_types/services-types';
import { ServicesTypesService } from '../_services/services-types.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ServicesTypesCompaniesService } from '../_services/services-types-companies.service';
import { ServiceTypeCompanyComponent } from './services-types-company/services-types-company.component';

@Component({
    selector: 'app-services-types-detail',
    templateUrl: './services-types-detail.component.html',
    styleUrls: ['./services-types-detail.component.scss'],
    standalone: false
})
export class ServicesTypesDetailComponent {
  public servicesTypeFormGroup!: RxFormGroup;
  public servicesType: ServiceType = new ServiceType();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public companies: any;
  public totalCompaniesRecords: number = 0;

  constructor(
    private servicesTypesService: ServicesTypesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private servicesTypesCompanyService: ServicesTypesCompaniesService,
    private dialogService: DialogService,
    private topbarService: TopbarService,
    private route: ActivatedRoute
  ) {
    this.servicesTypeFormGroup = this.formBuilder.formGroup<ServiceType>(this.servicesType) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de tipo de servicio");
    this.topbarService.addBreadcrumb("Tipos de servicios", "/servicesTypes");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadServicesType(id);
    }
    this.allowWrite = true;//this.loginService.hasPermission("SERVICES_TYPES_WRITE");
    this.allowDelete = true;//this.loginService.hasPermission("SERVICES_TYPES_DELETE");
  }

  async loadServicesType(id: string) {
    this.servicesType = await firstValueFrom(this.servicesTypesService.get(id));
    this.servicesTypeFormGroup.patchValue(this.servicesType);
    this.loadCompanies();

  }

  async loadCompanies() {  
    console.log("loadCompanies", this.servicesType.id);
      let filters = {
        serviceTypeId: new Filter(FilterOperation.equals, 'serviceTypeId', "", this.servicesType.id)
      };
  
      let params: IParamsCollection = {
        include: ['company', 'contract']
      }
      //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.servicesTypesCompanyService.all(params));
      this.companies = response.data;
      this.totalCompaniesRecords= response.meta["total"];
    }
  

  async save() {
    let valid = this.formValidationService.validateForm(this.servicesTypeFormGroup);
    if (valid) {
      this.servicesType = Object.assign(this.servicesType, this.servicesTypeFormGroup.value);
      
      let servicesType = await firstValueFrom(this.servicesTypesService.save(this.servicesType));

      this.messageService.add({ closable: true, severity: 'success', summary: "Tipo de servicio guardado correctamente." });
      this.router.navigate(['servicesTypes']);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tipo de servicio "+this.servicesType.name+"?",
      header: "Eliminar tipo de servicio",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.servicesTypesService.delete(this.servicesType.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de servicio eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
      this.router.navigate(['servicesTypes']);
  }

   addCompany(templateCompany: any, all:boolean) {
      const ref = this.dialogService.open(ServiceTypeCompanyComponent, {
        closable: true,
        modal: true,
        data: {
          templateCompanyId: templateCompany.id,
          companyId: (all ? templateCompany.companyId:null),
          serviceTypeId: this.servicesType.id
        },
        header: "Asignar compañía aseguradora",
        width: '40%'
      });
      ref.onClose.subscribe((data: any) => {
        setTimeout(() => {
          this.loadCompanies();
        }, 500);
      });
    }
    
    async deleteCompany(templateCompany: any) {
      var message = "¿Está seguro que desea desasignar el contrato  de la compañía aseguradora ?";
      this.confirmationService.confirm({
        message: message,
        header: "Desasignar contrato/s de companía aseguradora",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.servicesTypesCompanyService.delete(templateCompany.id).subscribe({
            next: (data: any) => {
              this.loadCompanies();
              this.messageService.add({ closable: true, severity: 'success', detail: "Contrato desasignada correctamente." });
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
  
    }
    

}
